module.exports = __webpack_public_path__ + "media/images/sports_coaching/card-mobile-eb5fb1de6de237a60bc8a844ffd3cc1e.jpg";